import { EventGroupListView } from "callable-data-objects";
import SimplePBXEvent from "callable-data-objects/dist/models/eventGroup/SimplePBXEvent";
import React from "react";
import { Header, Segment, Table } from "semantic-ui-react";

type EventPBXEventsViewType = {
  event: EventGroupListView;
};

const EventPBXEventsView = ({ event }: EventPBXEventsViewType) => {
  return (
    <Segment color='orange'>
      <Header as='h4'>PBX Events</Header>
      <Table stackable celled size='small'>
        <Table.Header>
          <Table.Row>
            <Table.Cell>ID</Table.Cell>
            <Table.Cell>Component</Table.Cell>
            <Table.Cell>Direction</Table.Cell>
            <Table.Cell>Event</Table.Cell>
            <Table.Cell>Extension</Table.Cell>
            <Table.Cell>From</Table.Cell>
            <Table.Cell>To</Table.Cell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {event.pbxEvents?.map((ev: SimplePBXEvent) => (
            <Table.Row key={`cdr-${ev.id}`}>
              <Table.Cell>{ev.id}</Table.Cell>
              <Table.Cell>{ev.component}</Table.Cell>
              <Table.Cell>{ev.direction}</Table.Cell>
              <Table.Cell>{ev.event}</Table.Cell>
              <Table.Cell>{ev.extension}</Table.Cell>
              <Table.Cell>{ev.from}</Table.Cell>
              <Table.Cell>{ev.to}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Segment>
  );
};

export default EventPBXEventsView;
